export default __webpack_public_path__ + "static/hero-tv-a7c6d4b0994c136f4109e0795fb4dffa.jpg";